import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { Article } from './article';
import { Stock } from './stock';
import { PrixAppel } from './prix-appel';

@JsonObject
export class FicheArticle {
  constructor (
    article?: Article,
    stock?: Stock,
    prixAppel?: PrixAppel
  ) {
    this.article = article as any;
    this.stock = stock as any;
    this.prixAppel = prixAppel as any;
  }

  @JsonProperty(Article)
  article: Article;

  @JsonProperty(Stock)
  stock: Stock;

  @JsonProperty(PrixAppel)
  @Optional
  prixAppel:PrixAppel;
}
